export enum RSP_ROLES {
  ADMIN = 'ADMIN',
  SUPER_USER = 'SUPER_USER',
  OPERATOR_ACCESS = 'OPERATOR_ACCESS',
  OPERATOR_INFO = 'OPERATOR_INFO',
  SUPPLIER = 'SUPPLIER',
  INTERNAL_USER = 'INTERNAL_USER',
  GUEST = 'GUEST',
  GE_TAG_ID_ADMIN = 'GE_TAG_ID_ADMIN',
  EOL_ADMIN = 'EOL_ADMIN',
}

export enum CONTRACT_ROLES {
  CONTRACT_ADMIN = 'CONTRACT_ADMIN',
  CONTRACT_EDITOR = 'CONTRACT_EDITOR',
  CONTRACT_VIEWER = 'CONTRACT_VIEWER'
}

export enum DOCSTORE_ROLES {
  DOCSTORE_ADMIN = 'DOCSTORE_ADMIN',
  DOCSTORE_EDITOR = 'DOCSTORE_EDITOR',
  DOCSTORE_VIEWER = 'DOCSTORE_VIEWER'
}

export enum ROLE_NAME {
  ADMIN = 'Administrator',
  SUPER_USER = 'Super User',
  OPERATOR_ACCESS = 'Access Management',
  OPERATOR_INFO = 'Portal Information',
  SUPPLIER = 'Supplier',
  INTERNAL_USER = 'Internal User',
  GUEST = 'Guest',
  CONTRACT_ADMIN = 'Contract Administrator',
  CONTRACT_EDITOR = 'Contract Editor',
  CONTRACT_VIEWER = 'Contract Viewer',
  DOCSTORE_ADMIN = 'Docstore Administrator',
  DOCSTORE_EDITOR = 'Docstore Editor',
  DOCSTORE_VIEWER = 'Docstore Viewer',
  GE_TAG_ID_ADMIN = 'GE Tag ID Admin',
  EOL_ADMIN = 'EOL Admin',
}

export enum APPLICATION {
  CLEAR_ORBIT = 'Clear Orbit',
  OTM = 'OTM',
  QUALITY_SUITES = 'Quality Suite',
  RACES_ISUPPLIER = 'RACES iSupplier',
  REN_TM = 'RenTM',
  REN_TT = 'RenTT',
  SDX = 'SDX',
  SPT = 'OSCAR',
  INTELEX_SUPPLIER_AUDIT = 'Intelex Supplier Audit',
  SRM = 'Supplier Portal / ScoreCard',
  SUPPLIER_CONNECT = 'SCx',
  GE_TAG_ID = 'GE Tag ID',
  EOL_DL = 'EOL DL',
}
export enum APPLICATION_KEY {
  CLEAR_ORBIT = 'CLEAR_ORBIT',
  OTM = 'OTM',
  QUALITY_SUITES = 'QUALITY_SUITES',
  RACES_ISUPPLIER = 'RACES_ISUPPLIER',
  REN_TM = 'REN_TM',
  REN_TT = 'REN_TT',
  SDX = 'SDX',
  SPT = 'SPT',
  INTELEX_SUPPLIER_AUDIT = 'INTELEX_SUPPLIER_AUDIT',
  SRM = 'SRM',
  SUPPLIER_CONNECT = 'SUPPLIER_CONNECT',
  GE_TAG_ID = 'GE_TAG_ID_REQUEST',
  EOL_DL = 'EOL_DL',
}

export enum TYPE {
  FILE = 'FILE',
  LINK = 'LINK',
}
